import { useEffect, useState } from "react";

const navLinks = [
  { label: "首页", href: "#top" },
  { label: "最新更新", href: "#updates" },
  { label: "精选套图", href: "#gallery" },
  { label: "视频资源", href: "#videos" },
  { label: "资源导航", href: "#categories" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-[68px] flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5 shrink-0">
          <span
            className={`w-9 h-9 flex items-center justify-center rounded-full ${
              solid ? "bg-primary-500 text-background-50" : "bg-background-50/90 text-primary-600"
            }`}
          >
            <i className="ri-leaf-line text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading font-bold text-[17px] tracking-tight ${
                solid ? "text-foreground-950" : "text-white"
              }`}
            >
              美丽的小蜜桃
            </span>
            <span
              className={`text-[10px] tracking-[0.28em] mt-0.5 ${
                solid ? "text-foreground-500" : "text-white/75"
              }`}
            >
              PHOTO &amp; VIDEO ARCHIVE
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`text-sm font-medium whitespace-nowrap transition-colors ${
                solid
                  ? "text-foreground-700 hover:text-primary-600"
                  : "text-white/85 hover:text-white"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <button
            type="button"
            aria-label="搜索资源"
            className={`w-10 h-10 flex items-center justify-center rounded-full transition-colors cursor-pointer ${
              solid
                ? "bg-background-100 text-foreground-700 hover:bg-background-200"
                : "bg-white/15 text-white hover:bg-white/25"
            }`}
          >
            <i className="ri-search-line text-lg" />
          </button>
          <a
            href="#subscribe"
            className="inline-flex items-center gap-1.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-5 h-10 rounded-full transition-colors whitespace-nowrap"
          >
            <i className="ri-notification-3-line" />
            订阅更新
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-full cursor-pointer ${
            solid ? "text-foreground-900 bg-background-100" : "text-white bg-white/15"
          }`}
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200/70 px-4 py-4">
          <div className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="py-3 text-sm font-medium text-foreground-800 border-b border-background-200/60 last:border-0"
              >
                {link.label}
              </a>
            ))}
          </div>
          <a
            href="#subscribe"
            onClick={() => setMenuOpen(false)}
            className="mt-4 inline-flex w-full items-center justify-center gap-1.5 bg-primary-500 text-background-50 text-sm font-medium h-11 rounded-full"
          >
            <i className="ri-notification-3-line" />
            订阅更新提醒
          </a>
        </div>
      )}
    </header>
  );
}